import { Logger } from './../../logger/Logger';
import _ from 'lodash';
import {
  AnnotationThread,
  CollectionScope,
  CommentId,
  FuidRrnInfo,
  GetAnnotationsMessage,
  GetAnnotationsQuery,
  GetAnnotationsResponse,
} from './../../autogenerated/ZoomBridge';
import ErrorId from './../../protocol/ErrorId';
import AnnotationUtil from './AnnotationUtil';

/**
 * Returns the available annotations for fiven Fuid, bid rrn.
 */
export default class GetAnnotations {

  /**
   * @param  {FuidRrnInfo} fuidRrnInfo Asset scope for comments.
   * @param {number} collectionId
   * @param {number} lastReceivedRrn RRN at which last annotation was received. If this is given, then only new annotations are returned.
   * @param {Function} onResult Called when results are received or any error has occurred..
   * @param {string} annotaionKind
   */
  constructor(fuidRrnInfo, collectionId, lastReceivedRrn, onResult, annotaionKind) {
    /**
     * @private
     * @tpye {number}
     */
    this.collectionId = collectionId;
    /**
     * @type {FuidRrnInfo}
     * @private
     */
    this.fuidRrnInfo = fuidRrnInfo;
    /**
     * @type {Logger}
     * @private
     */
    this.logger = new Logger('GetAnnotations');
    /**
     * @private
     * @type {GetAnnotationsResponse}
     */
    this.annotationsResponse = null;
    /**
     * @private
     * @type {Function}
     */
    this.onResult = onResult;
    /**
     * @type {ErrorId}
     * @private
     */
    this.errorId = null;

    /**
     * @type {AnnotationThread}
     * @private
     */
    this.currentAnnoationThread = null;
    if (this.logger.isDebug()) {
      // this.logger.debug("Going to fetch annotations/comments for: ", fuidRrnInfo);
    }
    if (!lastReceivedRrn) {
      lastReceivedRrn = -1;
    }
    /**
    * @type {GetAnnotationsQuery}
    */
    const query = new GetAnnotationsQuery();
    query.message = new GetAnnotationsMessage()
      .setFuidRrnInfo(fuidRrnInfo)
      .setCollectionScope(new CollectionScope().setCollectionId(this.collectionId))
      .setLastReceivedRrn(lastReceivedRrn)
      .setIncludeResolved(true)
      .setAnnotationKind(annotaionKind);
    query.run().then(this.onResponse, this.onError);
  }

  /**
   * @param  {GetAnnotationsResponse} response
   * @private
   */
  onResponse = (response) => {
    /**
     * @private
     * @type {GetAnnotationsResponse}
     */
    this.annotationsResponse = response;
    this.parseResult();
    if (this.onResult) {
      this.onResult(this);
    }
  }

  /**
   * Returns the Array of AnnotationThread
   * @return {Array.<AnnotationThread>}
   */
  getAnnotations() {
    return this.generalThreads;
  }

  getReviewAnnotations() {
    return this.reviewThreads ? this.reviewThreads : [];
  }

  /**
   * @private
   */
  parseResult() {
    if (!this.annotationsResponse) {
      return;
    }

    /**
     * @type {Array.<AnnotationThread>}
     */
    const threads = this.annotationsResponse.getThreads();
    if (_.size(threads) === 0) {
      return;
    }

    const reviewThreads = [];
    const generalThreads = [];
    _.each(threads, function (thread) {
      if (AnnotationUtil.isReviewAnnotation(thread)) {
        reviewThreads.push(thread);
      } else {
        generalThreads.push(thread);
      }
    });
    this.reviewThreads = reviewThreads;
    this.generalThreads = generalThreads;


    /* for (let i = 0; i < threads.length; i++) {
      this.currentAnnoationThread = threads[0];
    }
    this.currentAnnoationThread = null; */
  }

  /**
   * Called from above method to parse and filter each annotation.
   * @private
   */
  onEachAnnotationThread() {
    if (!this.currentAnnoationThread) {
      return;
    }

    //this.currentAnnoationThread.get
  }
  /**
   * @param  {ErrorId} errorId
   * @private
   */
  onError = (errorId) => {
    if (this.logger.isDebug()) {
      this.logger.debug("Error received in get annotations/comments.", errorId.toString());
    }
    this.errorId = errorId;
    if (this.onResult) {
      this.onResult(this);
    }
  }
  /**
   * @returns {Array.<number>} Array of deleted comments Ids
   */
  getDeletedCommentsId() {
    if (!this.deletedComments) {
      if (this.annotationsResponse) {
        /**
         * @type {Array.<CommentId>}
         */
        const arrayOfCommentIdsClass = this.annotationsResponse.getDeletedComments();
        if (_.size(arrayOfCommentIdsClass) > 0) {
          this.deletedComments = arrayOfCommentIdsClass.map(function (commentId) {
            return commentId.getCommentId();
          });
        }
      }
    }
    return this.deletedComments;
  }



  /**
   * @returns {number} RRN
   */
  getLastReceivedRrn() {
    if (this.annotationsResponse) {
      return this.annotationsResponse.getLastReceivedRrn();
    }
    return 0;
  }

  /**
   * @public
   * @returns {boolean} Returns true, if error Id is set.
   */
  hasError() {
    return !this.errorId;
  }

  /**
   * @public
   * @returns {string} Error string.
   */
  getErrorMessage() {
    return this.hasError() ? this.errorId.toString() : null;
  }



}